import {Card, Row, Col} from 'antd'
import LocationsMap from './locations-map'
import {useEffect, useState} from 'react'
import {Params, useFetchGet} from 'helpers/api'
import {useGatewaysSettings} from '@store/settings'
import {paginationDefaults, widthSmall} from 'helpers/style'
import PageHeader from './page-header'
import {DELTA_THERMAL_GLOBAL_HQ, MINZOOM, toLocations} from 'helpers/locations'
import {extractGateways} from 'helpers/results'
import TargetStatusLegend from './target-status-legend'
import TargetStatusTable from './target-status-table'
import {getAlphaLabel} from 'helpers/labels'
import {useDomain} from 'contexts/DomainContext'

const GatewaysMapRow = ({sitesview, handleGatewayClick}) => {
  const [gateways, setGateways] = useState()
  const [gatewaysMeta, setGatewaysMeta] = useState()
  const fetchGatewaysview = useFetchGet('gatewaysview')
  const [filter, setFilter, page, setPage, limit, setLimit] = useGatewaysSettings()
  const [locations, setLocations] = useState()
  const [minZoom, setMinZoom] = useState(MINZOOM.GATEWAYS)
  const {terms} = useDomain()

  const getGateways = () => {
    const params = Params({s_id: sitesview?.s_id, orderBy: 'g_name', order: 'ASC', filter, limit, page})
    fetchGatewaysview(params, response => {
      const gateways = extractGateways(response.gatewaysview)
      setGateways(gateways)
      setGatewaysMeta(response.meta)
      onGatewaysChange(gateways)
    })
  }

  useEffect(() => {
    if (sitesview) getGateways()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sitesview, filter])

  const onGatewaysChange = gateways => {
    if (gateways && gateways.length > 0) {
      let mapIndex = 0
      const items = gateways.reduce((acc, gateway) => {
        if (gateway.latitude && gateway.longitude) {
          const mapKey = getAlphaLabel(mapIndex)
          gateway.mapKey = mapKey
          const item = {
            key: mapKey,
            id: gateway.id,
            name: gateway.name,
            latitude: gateway.latitude,
            longitude: gateway.longitude
          }
          acc.push(item)
          mapIndex++
        }
        return acc
      }, [])

      setLocations(toLocations(items.reverse()))
    } else {
      // Show DT Headquarters location; leave off id to make not clickable
      setLocations(toLocations([DELTA_THERMAL_GLOBAL_HQ]))
      setMinZoom(MINZOOM.SITES)
    }
  }

  return (
    <Row gutter={16} style={{margin: '15px'}}>
      {/* Gateways Card - takes 1/4 width */}
      <Col xs={24} md={8}>
        <Card className={`w-${widthSmall}`}>
          <PageHeader
            ghost={false}
            onBack={() => window.history.back()}
            title={terms.gateways}
            subTitle=""
            backIcon={false}
          />
          <TargetStatusLegend mode={'horizontal'} />
          <TargetStatusTable
            items={gateways}
            handleItemClick={handleGatewayClick}
            pagination={paginationDefaults(gatewaysMeta?.total, limit, setLimit, gatewaysMeta?.page, setPage)}
          />
        </Card>
      </Col>

      {/* Locations Map Card - takes 3/4 width */}
      <Col xs={24} md={16}>
        <Card className="max-w-full">
          <div style={{height: '50vh', width: '61vw'}}>
            <LocationsMap
              locations={locations}
              onLocationClick={location => handleGatewayClick(location)}
              minZoom={minZoom}
            />
          </div>
        </Card>
      </Col>
    </Row>
  )
}

export default GatewaysMapRow
